import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

import { AppModule } from './app/app.module';

const faroId = import.meta.env['NG_APP_FARO_ID'];
const faroAppName = import.meta.env['NG_APP_FARO_APP_NAME'];
const faroUrl =
    'https://faro-collector-prod-eu-west-2.grafana.net/collect/' + faroId;

console.log('*** Faro App Name *** :', faroAppName);
console.log('*** Faro App URL *** :', faroUrl);

if (faroId && faroAppName) {
    initializeFaro({
        app: {
            name: faroAppName,
            version: '1.0.0',
        },
        instrumentations: [
            ...getWebInstrumentations(),
            new TracingInstrumentation(),
        ],
        url: faroUrl,
    });
}

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
